module.exports = __webpack_public_path__ + "img/magazine-cover-one.73a76e2b.jpg";